import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "@/locales/en";
import zh from "@/locales/zh";

Vue.use(VueI18n);

const messages = {
  en: en,
  zh: zh
};

// import

// function loadLocaleMessages() {
//   const locales = require.context("./locales/old", true, /[A-Za-z0-9-_,\s]+\.json$/i);
//   const messages = {};
//   locales.keys().forEach(key => {
//     const matched = key.match(/([a-z0-9]+)\./i);

//     if (matched && matched.length > 1) {
//       const locale = matched[1];
//       messages[locale] = locales(key);
//     }
//   });
//   return messages;
// }


// const loadedLanguages = ["en"];

// function setI18nLanguage(lang) {
//   i18n.locale = lang;
//   document.querySelector("html").setAttribute("lang", lang);
//   return lang;
// }

// export function loadLanguageAsync(lang) {
//   if (i18n.locale !== lang) {
//     if (!loadedLanguages.includes(lang)) {
//       return import(/* webpackChunkName: "lang-[request]" */ `@/locales/${lang}`).then(msgs => {
//         i18n.setLocaleMessage(lang, msgs.default);
//         loadedLanguages.push(lang);
//         return setI18nLanguage(lang);
//       });
//     }
//     return Promise.resolve(setI18nLanguage(lang));
//   }
//   return Promise.resolve(lang);
// }

const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: messages,
  silentTranslationWarn: true,
  numberFormats: {
    en: {
      currency: {
        // style: "decimal",
        // currency: "MYR",
        // currencyDisplay: "code",
        minimumFractionDigits: 2
      },
      integer: {
        minimumFractionDigits: 0
      }
    }
  },
  dateTimeFormats: {
    en: {
      short: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      },
      long: {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true
      }
    }
  }
});

export default i18n;
